import React from "react";
import { MdClose } from "react-icons/md";
import { Box, Flex } from "rebass";
import { getLocalizedString } from "../../utils";
import Fallback from "../../icons/Fallback";

const MiniCartItemMobile = ({
  modelCode = "",
  productId,
  orderId,
  imagedefault,
}) => {
  function deleteItem() {
    dispatchEvent(
      new CustomEvent("MINICART_DELETE", {
        bubbles: true,
        detail: {
          productId: productId,
          orderId: orderId,
          modelCode: modelCode,
          message: getLocalizedString("DELETEORDER_ITEM_MESSAGE_MINICART"),
          clearValues: true,
        },
      }),
    );
  }

  return (
    <div style={{ maxHeight: "250px" }}>
      <Flex
        bg="#232323"
        width="18px"
        height="18px"
        style={{
          position: "relative",
          top: "15px",
          right: "-130px",
          borderRadius: "9px",
          zIndex: 10,
        }}
        alignItems="center"
        justifyContent="center"
        onClick={deleteItem}
      >
        <MdClose color="white" />
      </Flex>
      <Flex mx="10px" minWidth="130px" style={{ border: "1px solid #f3f3f3" }}>
        {imagedefault ? (
          <img
            src={imagedefault}
            alt=""
            style={{ width: "130px", height: "220px", pointerEvents: "none" }}
          />
        ) : (
          <Fallback style={{ width: "130px", height: "220px" }}></Fallback>
        )}
      </Flex>
    </div>
  );
};

export default MiniCartItemMobile;
